<template>
<div class="poi-container" :class="{'mobile': isMobile, 'closing': closing, 'outside-slideout': isMobile && !inSlideout}">

    <!-- Sticky navbar with Back (mobile) -->
    <div class="poi-navbar" v-if="isMobile && inSlideout && (!images || images.length === 0) && !showAllReviewsInPanel && !showEditorInPanel">
        <vs-button transparent class="back-cta nav" aria-label="Indietro" title="Indietro" @click.stop="closeWithAnimation" @touchend.stop.prevent="closeWithAnimation" @mousedown.stop @touchstart.stop>
            <img src="../../assets/icons/back.png" alt="" />
            <span>Indietro</span>
        </vs-button>
    </div>

    <div class="poi-hero" v-if="images && images.length > 0 && !showAllReviewsInPanel && !showEditorInPanel">
        <vs-button transparent class="back-cta overlay" v-if="isMobile && inSlideout && !showAllReviewsInPanel && !showEditorInPanel" @click.stop="closeWithAnimation" @touchend.stop.prevent="closeWithAnimation" @mousedown.stop @touchstart.stop>
            <img src="../../assets/icons/back.png" style="width: 20px; height: 20px; margin-right: 6px;" />
            Indietro
        </vs-button>

        <div class="ai-source-chip" v-if="fromAssistant">
            <img src="../../assets/icons/ai.png" alt="" />
            <span>Suggerito dall'Assistente</span>
        </div>

        <div class="swiper">
            <div class="swiper-wrapper" id="lg-swipper">
                <a v-for="(image,i) in images" :key="'image-'+i" class="swiper-slide" :data-src="image.url" :data-sub-html="image.description">
                    <img class="img-responsive" loading="lazy" :src="image.url" />
                    <p style="margin: 0;">{{ image.description }}</p>
                </a>
            </div>

            <!--navigation-->
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
        </div>
    </div>

    <div class="poi-top-row" v-if="!showAllReviewsInPanel && !showEditorInPanel" style="width: 100%; display: flex; justify-content: space-between; align-items: center; gap: 10px;" :style="{paddingLeft: isMobile ? '20px' : '0', paddingRight: isMobile ? '22px' : '0', boxSizing: isMobile ? 'border-box' : 'unset'}">
        <!-- back button moved to sticky navbar -->
        <vs-row direction="row" justify="flex-start" align="center" style="max-width: calc(100% - 50px);">
            <img class="poi-target-icon" v-if="poi != null" :src="targets[poi.target_id]" style="width: auto; height: 64px;" />

            <div style="display: flex; justify-content: center; flex-direction: column; gap: 5px; max-width: calc(100% - 70px);">
                <h3 style="margin: 0;" :style="{textAlign: isMobile ? 'left': 'unset'}">{{ poi != null ? poi.name : 'Loading..' }}</h3>
                <p class="subtitle" v-if="poi != null" :style="{textAlign: isMobile ? 'left': 'unset'}">{{ poi.target_name }}</p>
                <div style="display: flex; justify-content: flex-start; align-items: center; gap: 10px;" v-if="!isMobile">
                    <Stars :stars="poi != null ? Math.floor(poi.average_rating) : 0" />
                    <p style="margin: 0;" class="light">{{ poi != null ? poi.number_of_reviews : 0 }} {{ $t('common.reviews') }}</p>
                </div>
            </div>
        </vs-row>


        <vs-tooltip v-model="upgradeTooltip" not-arrow not-hover :bottom="isMobile" :left="!isMobile" border color="#EF7E18" style="padding: 0; margin: 0;" v-if="user != null">
            <vs-button v-if="poi != null && poi.my_place" @click="togglePoiMyPlaces" dark color="#FFE6D0" style="width: 50px;"><img src="../../assets/icons/pin.png" style="width:24px;" /></vs-button>
            <vs-button v-else @click="togglePoiMyPlaces" dark style="width: 50px;"><img src="../../assets/icons/pin_grey.png" style="width:24px;" /></vs-button>

            <template #tooltip>
                <div class="content-tooltip">
                    <h4 class="center">
                        {{ $t('common.thisFeatureIsOnlyAvailableInPremiumVersion') }}
                    </h4>
                    <footer>
                        <vs-button block size="large" @click="upgrade" :loading="upgradeLoading">
                            {{ $t('profile.subscription.upgrade') }}
                        </vs-button>
                    </footer>
                </div>
            </template>
        </vs-tooltip>
    </div>

    <div style="display: flex; justify-content: flex-start; align-items: center; gap: 10px; width: 100%; padding-left: 22px; box-sizing: border-box;" v-if="isMobile && !showAllReviewsInPanel && !showEditorInPanel">
        <Stars :stars="poi != null ? Math.floor(poi.average_rating) : 0" />
        <p style="margin: 0;" class="light">{{ poi != null ? poi.number_of_reviews : 0 }} {{ $t('common.reviews') }}</p>
    </div>
    <!--Mobile action pills
    <div class="poi-actions" v-if="isMobile">
        <div class="poi-actions-scroll">
            <vs-button class="action-pill primary" @click="getDirections">
                <img src="../../assets/icons/direction.png" alt="" />
                {{ $t('poi.getDirections') }}
            </vs-button>
            <vs-button class="action-pill" @click="addToTrip">
                <img src="../../assets/icons/trip.png" alt="" />
                {{ $t('poi.addToTrip') }}
            </vs-button>
            <vs-button class="action-pill" :disabled="poi == null || poi.website == ''" @click="openWebsite">
                <img src="../../assets/icons/www.png" alt="" />
                Sito web
            </vs-button>
        </div>
    </div>-->


    <div class="poi-section" v-if="!isMobile && !showAllReviewsInPanel && !showEditorInPanel">
        <p class="bold">{{ $t('common.target') }}</p>
        <p>{{ poi != null ? poi.target_name : 'Loading..' }}</p>
    </div>

    <div class="poi-section" v-if="!showAllReviewsInPanel && !showEditorInPanel">
        <p class="bold">{{ $t('poi.yearOfConstruction') }}</p>
        <p>{{ poi != null ? poi.year_built : '----' }}</p>
    </div>

    <div class="poi-section" v-if="!showAllReviewsInPanel && !showEditorInPanel">
        <p class="bold">{{ $t('poi.author') }}</p>
        <p>{{ poi != null ? (poi.author == '' ? '-' : poi.author) : 'Loading..' }}</p>
    </div>

    <div class="poi-section" v-if="!showAllReviewsInPanel && !showEditorInPanel">
        <p class="bold">{{ $t('poi.description') }}</p>
        <p>{{ poi != null ? (fullDescription ? poi.description : poi.description.substr(0,200)) : 'Loading..'}}</p>
        <a style="cursor: pointer;" @click="fullDescription = true" v-if="!fullDescription && poi != null && poi.description.length > 200">{{ $t('common.showMore') }}</a>
        <a style="cursor: pointer;" @click="fullDescription = false" v-if="fullDescription">{{ $t('common.showLess') }}</a>
    </div>

    <div v-if="!showAllReviewsInPanel && !showEditorInPanel" style="display: flex; justify-content: space-between; width: 100%; gap: 15px;" :style="{paddingLeft: isMobile ? '22px' : '0', paddingRight: isMobile ? '22px' : '0', boxSizing: isMobile ? 'border-box' : 'unset'}">
        <vs-button dark block class="bold" @click="addToTrip"><img src="../../assets/icons/trip.png" style="width: 24px;" @click="addToTrip" />{{ $t('poi.addToTrip').toUpperCase() }}</vs-button>
        <vs-button v-if="poi != null && poi.liked" @click="togglePoiLike" dark color="#FFE6D0" style="width: 50px;"><img src="../../assets/icons/favourite.png" style="width:24px;" /></vs-button>
        <vs-button v-else @click="togglePoiLike" dark style="width: 50px;"><img src="../../assets/icons/favourite_grey.png" style="width:24px;" /></vs-button>
    </div>

    <div v-if="!showAllReviewsInPanel && !showEditorInPanel" style="display: flex; justify-content: flex-start; width: 100%; align-items: center; gap: 5px;" :style="{paddingLeft: isMobile ? '22px' : '0', paddingRight: isMobile ? '22px' : '0', boxSizing: isMobile ? 'border-box' : 'unset'}">
        <img src="../../assets/icons/location.png" style="width: 24px; height: 24px;" />
        <p class="bold">{{ poi != null ? poi.street : 'Loading..' }}</p>
    </div>

    <div class="map-gradient" v-if="!showAllReviewsInPanel && !showEditorInPanel">
        <div class="gradient"></div>
        <OpenStreetMap style="width: 100%; height: 120px; " v-if="poi != null" :controls-enabled="false" :center="[poi.latitude, poi.longitude]" :pois="[poi]" />
    </div>

    <div v-if="!showAllReviewsInPanel && !showEditorInPanel" style="display: flex; justify-content: space-between; width: 100%; gap: 15px;" :style="{paddingLeft: isMobile ? '22px' : '0', paddingRight: isMobile ? '22px' : '0', boxSizing: isMobile ? 'border-box' : 'unset', marginTop: '10px'}">
        <vs-button dark block class="bold" @click="getDirections"><img src="../../assets/icons/direction.png" style="width: 18px;" />{{ $t('poi.getDirections').toUpperCase() }}</vs-button>
        <vs-button dark style="width: 50px;" :alt="poi != null ? poi.website : ''" @click="openWebsite" :disabled="poi == null || poi.website == ''"><img src="../../assets/icons/www.png" style="width: 30px;" /></vs-button>
    </div>

    <div v-if="!showAllReviewsInPanel && !showEditorInPanel" style="display: flex; justify-content: space-between; align-items: center; width: 100%;" :style="{paddingLeft: isMobile ? '22px' : '0', paddingRight: isMobile ? '22px' : '0', boxSizing: isMobile ? 'border-box' : 'unset'}">
        <p class="bold">{{ $t('common.reviews') }}</p>
        <p class="bold" style="display: flex; align-items: center; gap: 5px; cursor: pointer;" @click="onShowAllReviews">{{ $t('common.showAll') }} <img src="../../assets/icons/right.png" style="width: 16px;" /></p>
    </div>

    <!-- reviews is valued by reviews component once get the reviews, we need this to show the pictures -->
    <Reviews v-if="!showAllReviewsInPanel && !showEditorInPanel" ref="embeddedReviews" :poi="poi" :user="user" :in-slideout="inSlideout" :open-editor="onOpenEditorInPanel" :poi-id="poi != null ? poi.id : null" v-model="reviews" :style="{paddingLeft: isMobile ? '22px' : '0', paddingRight: isMobile ? '22px' : '0', boxSizing: isMobile ? 'border-box' : 'unset'}"  />

    <!-- Embedded full reviews view when opened inside slideout panel -->
    <div v-if="showAllReviewsInPanel" class="reviews-panel-embed" :style="{paddingLeft: isMobile ? '22px' : '0', paddingRight: isMobile ? '22px' : '0', boxSizing: isMobile ? 'border-box' : 'unset', width: isMobile ? '100%' : 'unset'}">
        <div class="poi-navbar reviews-navbar">
            <vs-button transparent class="back-cta nav" aria-label="Indietro" title="Indietro" @click="showAllReviewsInPanel = false">
                <img src="../../assets/icons/back.png" alt="" />
                <span>Indietro</span>
            </vs-button>
            <div class="grabber-handle" aria-hidden="true"></div>
            <div class="title">{{ $t('common.reviews') }}</div>
        </div>
        <Reviews ref="embeddedReviews" :poi="poi" :user="user" :in-slideout="inSlideout" :open-editor="onOpenEditorInPanel" :poi-id="poi != null ? poi.id : null" />
    </div>

    <!-- Embedded new/edit review editor when opened inside slideout panel -->
    <div v-if="showEditorInPanel" class="reviews-panel-embed" :style="{paddingLeft: isMobile ? '22px' : '0', paddingRight: isMobile ? '22px' : '0', boxSizing: isMobile ? 'border-box' : 'unset', width: isMobile ? '100%' : 'unset'}">
        <div class="poi-navbar reviews-navbar">
            <vs-button transparent class="back-cta nav" aria-label="Indietro" title="Indietro" @click="onEditorClose">
                <img src="../../assets/icons/back.png" alt="" />
                <span>Indietro</span>
            </vs-button>
            <div class="grabber-handle" aria-hidden="true"></div>
        </div>
        <NewReview embedded :poi-id="poi != null ? poi.id : null" :review-id="editReviewId" :on-close="onEditorClose" @saved="onEditorSaved" />
    </div>

</div>
</template>

<script>
import { Browser } from '@capacitor/browser';

import {
    apiCall,
    baseUri
} from '../../utils/ApiMiddleware';

import {
    s3Client
} from '@/utils/S3Client';

import Stars from '../Stars.vue'
import OpenStreetMap from '../OpenStreetMap.vue';
import Reviews from '../Reviews.vue';
import NewReview from '../elements/NewReview.vue';
import AddToTripDialog from '../dialogs/AddToTripDialog.vue';
import TripDateDialog from '../dialogs/TripDateDialog.vue';
import NewTripDialog from '../dialogs/NewTripDialog.vue';
import {
    GlobalEventEmitter
} from '@/utils/GlobalEventEmitter'
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

// import Swiper styles
export default {
    name: "poi",
    props: {
        user: Object,

        isMobile: {
            type: Boolean,
            default: false
        },

        poiId: {
            type: [String, Number],
            default: null
        },

        close: {
            type: Function,
            default: null
        },

        // optional: allow caller to set initial sheet height ratio on mobile (0..1)
        initialSheetRatio: {
            type: Number,
            default: 0.6
        },
        fromAssistant: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Stars,
        OpenStreetMap,
        Reviews,
        NewReview,
    },

    data() {
        return {
            poi: null,
            fullDescription: false,
            selectedTrip: null,
            baseUri,
            upgradeTooltip: false,
            upgradeLoading: false,

            googleImages: [], // obtained from S3
            images: [], // images to show in the gallery
            reviews: [],
            loadingImages: true,

            // Bottom sheet drag state
            dragging: false,
            panelEl: null,
            innerEl: null,
            panelId: null,
            startY: 0,
            startHeight: 0,
            sheetHeight: null,
            sheetHandleGuard: 180,
            closing: false,
            onOutsidePointer: null,
            inSlideout: false,
            showAllReviewsInPanel: false,
            showEditorInPanel: false,
            editReviewId: null,

            // overscroll guard state for slideout
            osStartY: 0,
            osOnStart: null,
            osOnMove: null,
        }
    },

    async mounted() {
        const id = this.poiId || (this.$route && this.$route.params ? this.$route.params.id : null);
        if (id != null) {
            await this.getPoi(id);
        }
        try { this.inSlideout = !!this.findPanelEl(); } catch (e) { console.warn(e); }
        if (this.isMobile) {
            this.$nextTick(() => {
                this.setupSheetDrag();
                this.installOverscrollGuard();
            });
        }

        // If opened from AI on mobile, tapping outside the sheet closes it
        if (this.isMobile && this.fromAssistant) {
            this.onOutsidePointer = (ev) => {
                try {
                    const t = ev && ev.target;
                    if (this.innerEl && t && !this.innerEl.contains(t)) {
                        if (ev && ev.cancelable) ev.preventDefault();
                        if (ev && ev.stopPropagation) ev.stopPropagation();
                        this.closeWithAnimation();
                    }
                } catch (e) { console.warn(e); }
            };
            try {
                document.addEventListener('touchstart', this.onOutsidePointer, true);
                document.addEventListener('mousedown', this.onOutsidePointer, true);
            } catch (e) { console.warn(e); }
        }
    },

    beforeDestroy() {
        try {
            if (this.onOutsidePointer) {
                document.removeEventListener('touchstart', this.onOutsidePointer, true);
                document.removeEventListener('mousedown', this.onOutsidePointer, true);
                this.onOutsidePointer = null;
            }
        } catch (e) { console.warn(e); }
        try {
            this.removeOverscrollGuard();
        } catch (e) { console.warn(e); }
    },

    computed: {
        targets() {
            return this.$TARGETS.icons;
        }
    },

    watch: {
        async reviews(n) { // reviews are always loaded after poi details, so we are sure that poi pictures will be already loaded
            let tempImages = this.googleImages;

            // if reviews are loaded, and there are no pictures in poi, show them as pictures
            if (n != null) {
                let reviewImages = await Promise.all(
                    n.filter(e => e.pictures != null && e.pictures.length > 0).map(async (review) => {
                        const pictureUrls = await Promise.all(
                            review.pictures.map(async (picture) => {
                                console.log('PICTURESSS',picture)
                                const response = await s3Client.getSignedDownloadURL({
                                    name: picture,
                                });
                                console.log(response)
                                if (response && response.url) {
                                    return {
                                        url: response.url,
                                        description: review.user.name + (review.user.surname ? ' ' + review.user.surname : ''),
                                        transition: 'kenburn'
                                    };
                                }
                                return null;
                            })
                        );
                        return pictureUrls.filter(p => p !== null); // Filter out null entries
                    })
                );

                reviewImages = reviewImages.flat();

                if (reviewImages && reviewImages.length > 0) {
                    tempImages = tempImages.concat(reviewImages);
                }
            }


            // show gallery if there is at least one image
            if (tempImages.length > 0) {
                this.images = tempImages;
                // at next tick, init the gallery, in this way we are sure DOM is updated
                this.$nextTick(() => {
                    this.initGallery();
                })
            }

            console.log(JSON.parse(JSON.stringify(this.images)))
        }
    },

    methods: {
        handleClose(){
            if(this.close){
                this.close();
            } else {
                // fallback for safety
                this.$emit('close');
            }
        },

        onShowAllReviews(){
            if (this.inSlideout && this.isMobile) {
                this.showAllReviewsInPanel = true;
                this.showEditorInPanel = false;
                this.$nextTick(() => {
                    try {
                        const el = this.$el.querySelector('.reviews-panel-embed');
                        if (el && el.scrollIntoView) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
                    } catch(e){ /* no-op */ }
                });
            } else {
                this.$router.push({name: 'Recensioni'});
            }
        },

        onOpenEditorInPanel(id) {
            this.editReviewId = id || null;
            this.showEditorInPanel = true;
            this.showAllReviewsInPanel = false;
            this.$nextTick(() => {
                try {
                    const el = this.$el.querySelector('.reviews-panel-embed');
                    if (el && el.scrollIntoView) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
                } catch(e) { /* no-op */ }
            });
        },

        onEditorClose() {
            this.showEditorInPanel = false;
            this.editReviewId = null;
            // if we were in the full reviews view, keep that visible after closing editor
            if (this.inSlideout && this.isMobile) {
                this.showAllReviewsInPanel = true;
            }
            // refresh reviews list if available
            try {
                if (this.$refs.embeddedReviews && this.$refs.embeddedReviews.getReviews) {
                    this.$refs.embeddedReviews.after = null;
                    this.$refs.embeddedReviews.getReviews(true);
                }
            } catch (_) { /* no-op */ }
        },

        onEditorSaved() {
            this.onEditorClose();
        },

        // Smooth close animation before hiding the slideout panel
        // Resize the map first (remove panel height + mark panel closed), then slide the card off-screen.
        closeWithAnimation(){
            if(!this.isMobile){ this.handleClose(); return; }
            try {
                // 1) Tell layout to expand the map behind the sheet immediately
                try {
                    GlobalEventEmitter.$emit('setMobileNavbarVisible', true);
                    GlobalEventEmitter.$emit('poiPanelClose');                 // make Explore.vue stop reserving space for the sheet
                    GlobalEventEmitter.$emit('poiSheetHeightChanged', 0);      // collapse reserved height
                    GlobalEventEmitter.$emit('invalidateMap');                 // recalc map size
                } catch(_) {console.warn(_);}

                this.closing = true;

                // Ensure references to slideout DOM exist
                if(!this.innerEl){
                    this.findPanelEl();
                }

                const startSlide = () => {
                    if(this.innerEl){
                        // 2) Slide the sheet fully off-screen (downwards)
                        try {
                            this.innerEl.style.setProperty('transition', 'transform 320ms cubic-bezier(.2,.8,.2,1)', 'important');
                            this.innerEl.style.setProperty('transform', 'translateY(100vh)', 'important');
                        } catch(_) {console.warn(_);}
                        if (this.innerEl.classList) {
                            this.innerEl.classList.add('closing');
                        }
                    }
                };

                // Give layout one tick to apply the map resize, then animate
                setTimeout(startSlide, 10);

            } catch(e){ console.warn(e); }

            // 3) After the animation completes, actually hide the panel
            setTimeout(() => {
                this.handleClose();
            }, 360);
        },

        // Setup draggable bottom sheet like Google Maps
        setupSheetDrag() {
            console.log('[POI] setupSheetDrag()');
            if(!this.isMobile){ return; }
            // find the panel element wrapping this component
            this.panelEl = this.findPanelEl();
            if (!this.panelEl) {
                return;
            }
            // mark that we're inside slideout context
            this.inSlideout = true;
            // Ensure POI slideout is above AI assistant panel
            try { this.panelEl.style.setProperty('z-index', '2310', 'important'); } catch (e) { console.warn(e); }
            if (this.innerEl) {
                try { this.innerEl.style.setProperty('z-index', '2311', 'important'); } catch (e) { console.warn(e); }
            }

            // initial height: 60% of viewport, clamped
            const vh = window.innerHeight || document.documentElement.clientHeight;
            const maxH = Math.max(140, Math.round(vh - this.sheetHandleGuard));
            const minH = Math.max(140, Math.round(vh * 0.18));
            if (!this.sheetHeight) {
                const ratio = (typeof this.initialSheetRatio === 'number' && this.initialSheetRatio > 0 && this.initialSheetRatio < 1) ? this.initialSheetRatio : 0.6;
                this.sheetHeight = Math.round(vh * ratio);
            }
            this.sheetHeight = Math.min(Math.max(this.sheetHeight, minH), maxH);
            console.log('[POI] setupSheetDrag panelEl:', this.panelId, 'min/max:', minH, maxH, 'init height:', this.sheetHeight);
            this.setPanelHeight(this.sheetHeight, false);
            try { GlobalEventEmitter.$emit('poiSheetHeightChanged', this.sheetHeight); } catch (e) {console.warn(e);}
            // attach handle listeners on the slideout top area (use existing ::after visual handle)
            if (this.innerEl && this.innerEl.classList && this.innerEl.classList.contains('poi-mobile-panel')) {
                try {
                    this.innerEl.addEventListener('mousedown', this.onHandlePointerDown);
                    this.innerEl.addEventListener('touchstart', this.onHandlePointerDown, { passive: false });
                } catch (e) { console.warn(e); }
            }

            // clean listeners on destroy
            this.$once('hook:beforeDestroy', () => {
                window.removeEventListener('mousemove', this.onGrabMove);
                window.removeEventListener('touchmove', this.onGrabMove);
                window.removeEventListener('mouseup', this.onGrabEnd);
                window.removeEventListener('touchend', this.onGrabEnd);
                window.removeEventListener('touchcancel', this.onGrabEnd);
                if (this.innerEl) {
                    try {
                        this.innerEl.removeEventListener('mousedown', this.onHandlePointerDown);
                        this.innerEl.removeEventListener('touchstart', this.onHandlePointerDown);
                    } catch (e) { console.warn(e); }
                }
            });
        },

        installOverscrollGuard() {
            // Prevent iOS rubber-band overscroll inside the slideout content so the top handle is easier to grab/resize
            if (!this.isMobile) return;
            const scroller = this.$el && this.$el.querySelector('.poi-container.mobile');
            if (!scroller) return;
            if (this.osOnStart || this.osOnMove) return; // already installed

            this.osOnStart = (e) => {
                const t = (e.touches && e.touches[0]) ? e.touches[0] : e;
                this.osStartY = (t && typeof t.clientY === 'number') ? t.clientY : 0;
            };
            this.osOnMove = (e) => {
                if (!scroller) return true;
                const t = (e.touches && e.touches[0]) ? e.touches[0] : e;
                const currentY = (t && typeof t.clientY === 'number') ? t.clientY : 0;
                const dy = currentY - this.osStartY;

                const atTop = scroller.scrollTop <= 0;
                const atBottom = Math.ceil(scroller.scrollTop + scroller.clientHeight) >= scroller.scrollHeight;

                // If at top and pulling down, or at bottom and pushing up, prevent default to avoid rubber-band overscroll
                if ((atTop && dy > 0) || (atBottom && dy < 0)) {
                    if (e && e.cancelable) e.preventDefault();
                    if (e && e.stopPropagation) e.stopPropagation();
                    return false;
                }
                return true;
            };

            try {
                scroller.addEventListener('touchstart', this.osOnStart, { passive: true });
                scroller.addEventListener('touchmove', this.osOnMove, { passive: false });
            } catch (e) { console.warn(e); }
        },

        removeOverscrollGuard() {
            const scroller = this.$el && this.$el.querySelector('.poi-container.mobile');
            try {
                if (scroller && this.osOnStart) scroller.removeEventListener('touchstart', this.osOnStart);
                if (scroller && this.osOnMove) scroller.removeEventListener('touchmove', this.osOnMove);
            } catch (e) { console.warn(e); }
            this.osOnStart = null;
            this.osOnMove = null;
        },

        findPanelEl() {
            console.log('[POI] findPanelEl() from', this.$el && this.$el.id);
            // climb up DOM to element with id starting with slide-out-panel-
            let el = this.$el;
            while (el && el !== document.body) {
                if (el.id && el.id.indexOf('slide-out-panel-') === 0) {
                    this.panelId = el.id;
                    this.innerEl = (el.classList && el.classList.contains('slideout')) ? el : el.querySelector('.slideout');
                    console.log('[POI] findPanelEl found ancestor', this.panelId, 'inner:', !!this.innerEl);
                    return el;
                }
                el = el.parentElement;
            }
            // fallback using closest selector if supported
            try {
                const candidate = this.$el.closest('[id^="slide-out-panel-"]');
                if (candidate) {
                    this.panelId = candidate.id;
                    this.innerEl = (candidate.classList && candidate.classList.contains('slideout')) ? candidate : candidate.querySelector('.slideout');
                    console.log('[POI] findPanelEl found via closest', this.panelId, 'inner:', !!this.innerEl);
                    return candidate;
                }
            } catch (e) {console.warn(e);}
            return null;
        },

        setPanelHeight(h, animate = true) {
            if(!this.isMobile){ return; }
            const rounded = Math.round(h);
            const heightPx = `${rounded}px`;
            const vh = (window.innerHeight || document.documentElement.clientHeight) | 0;
            const topPx = `${Math.max(this.sheetHandleGuard, vh - rounded)}px`;

            console.log('[POI] setPanelHeight', h, 'animate:', animate, 'panelEl:', !!this.panelEl, 'innerEl:', !!this.innerEl, 'topPx:', topPx);
            if (!this.panelEl) return;

            // Apply transition to both containers
            const transitionVal = animate ? 'height 180ms ease, top 180ms ease' : 'none';
            this.panelEl.style.transition = transitionVal;

            // Expose height to CSS as variable as well
            try {
                this.panelEl.style.setProperty('--sheet-height', heightPx, 'important');
            } catch (e) {console.warn(e);}

            // Try to resize the wrapper
            try {
                this.panelEl.style.setProperty('height', heightPx, 'important');
                this.panelEl.style.setProperty('max-height', heightPx, 'important');
                // Ensure the slideout wrapper doesn't clip inner content (fix cropped buttons/edges)
                this.panelEl.style.setProperty('overflow', 'visible', 'important');
            } catch (e) {
                console.warn('[POI] failed to set wrapper height', e);
            }

            // Resize/position the inner slideout (the visible card) overriding library constraints
            if (this.innerEl) {
                try {
                    this.innerEl.style.setProperty('--sheet-height', heightPx, 'important');
                    this.innerEl.style.setProperty('transition', transitionVal);
                    this.innerEl.style.setProperty('height', heightPx, 'important');
                    this.innerEl.style.setProperty('max-height', heightPx, 'important');
                    // Ensure rounded top corners are visible and content is clipped to the radius
                    this.innerEl.style.setProperty('overflow', 'hidden', 'important');
                    this.innerEl.style.setProperty('border-top-left-radius', '18px', 'important');
                    this.innerEl.style.setProperty('border-top-right-radius', '18px', 'important');
 
                    // Pin to bottom and compute top so increasing height lifts the top edge up
                    this.innerEl.style.setProperty('bottom', '0', 'important');
                    this.innerEl.style.setProperty('top', topPx, 'important');
 
                    // Neutralize potential translateY used by the lib for openOn: 'bottom'
                    this.innerEl.style.setProperty('transform', 'none', 'important');

                    const rect = this.innerEl.getBoundingClientRect();
                    console.log('[POI] innerEl rect.h =>', rect.height);
                    try { GlobalEventEmitter.$emit('poiSheetHeightChanged', rounded); } catch (e) {console.warn(e);}
                } catch (e) {
                    console.warn('[POI] failed to set inner height/top', e);
                }
            }
        },

        onGrabStart(evt) {
            console.log('[POI] onGrabStart', evt && evt.type);
            const y = this.getClientY(evt);
            if (y == null) return;
            if (!this.panelEl) {
                this.panelEl = this.findPanelEl();
                if (!this.panelEl) return;
            }
            this.dragging = true;
            this.startY = y;
            this.startHeight = this.panelEl.offsetHeight || (this.sheetHeight || 0);
            console.log('[POI] onGrabStart y:', y, 'startHeight:', this.startHeight);

            // attach listeners
            window.addEventListener('mousemove', this.onGrabMove, { passive: false });
            window.addEventListener('touchmove', this.onGrabMove, { passive: false });
            window.addEventListener('mouseup', this.onGrabEnd);
            window.addEventListener('touchend', this.onGrabEnd);
            window.addEventListener('touchcancel', this.onGrabEnd);

            // avoid text selection/scroll bounce
            document.documentElement.style.userSelect = 'none';
            document.body.style.overscrollBehaviorY = 'contain';

            // remove any transition for live dragging
            if (this.panelEl) this.panelEl.style.transition = 'none';
        },

        onGrabMove(evt) {
            // verbose logs
            console.log('[POI] onGrabMove', evt && evt.type, 'dragging:', this.dragging);
            if (!this.dragging) return;
            if (evt && typeof evt.preventDefault === 'function') {
                evt.preventDefault();
            }
            const y = this.getClientY(evt);
            if (y == null) return;
            const dy = this.startY - y; // dragging up => positive
            const vh = window.innerHeight || document.documentElement.clientHeight;
            const maxH = Math.max(140, Math.round(vh - this.sheetHandleGuard));
            const minH = Math.max(140, Math.round(vh * 0.18));

            let next = this.startHeight + dy;
            if (next < minH) next = minH;
            if (next > maxH) next = maxH;
            this.sheetHeight = next;
            console.log('[POI] onGrabMove next height:', next);
            this.setPanelHeight(next, false);
            try {
                console.log('[POI] emit poiSheetHeightChanged (move):', Math.round(next));
                GlobalEventEmitter.$emit('poiSheetHeightChanged', Math.round(next));
            } catch (e) { console.warn(e); }
        },

        onGrabEnd() {
            console.log('[POI] onGrabEnd dragging:', this.dragging);
            if (!this.dragging) return;
            this.dragging = false;

            // snap to nearest stop
            const vh = window.innerHeight || document.documentElement.clientHeight;
            const stops = [
                Math.max(140, Math.round(vh * 0.18)), // collapsed
                Math.round(vh * 0.55),                 // half
                Math.round(vh - this.sheetHandleGuard)  // expanded (leave grabber visible)
            ];
            const target = stops.reduce((best, h) => {
                return Math.abs(h - this.sheetHeight) < Math.abs(best - this.sheetHeight) ? h : best;
            }, stops[0]);

            this.sheetHeight = target;
            console.log('[POI] onGrabEnd snap to', target);
            this.setPanelHeight(target, true);
            try {
                console.log('[POI] emit poiSheetHeightChanged (end):', Math.round(target));
                GlobalEventEmitter.$emit('poiSheetHeightChanged', Math.round(target));
            } catch (e) { console.warn(e); }

            // cleanup
            window.removeEventListener('mousemove', this.onGrabMove);
            window.removeEventListener('touchmove', this.onGrabMove);
            window.removeEventListener('mouseup', this.onGrabEnd);
            window.removeEventListener('touchend', this.onGrabEnd);
            window.removeEventListener('touchcancel', this.onGrabEnd);
            document.documentElement.style.userSelect = '';
            document.body.style.overscrollBehaviorY = '';

            // optional: let map/layout reflow
            this.$nextTick(() => {
                // reserved for future adjustments (e.g., emit map recenter)
            });
        },

        getClientY(evt) {
            if (!evt) return null;
            if (evt.touches && evt.touches.length > 0) return evt.touches[0].clientY;
            if (evt.changedTouches && evt.changedTouches.length > 0) return evt.changedTouches[0].clientY;
            if (typeof evt.clientY === 'number') return evt.clientY;
            return null;
        },

        onHandlePointerDown(evt) {
            // Start drag only if the pointer is on the slideout's top handle area (matching ::after)
            if (!this.innerEl) return;

            // Do NOT initiate drag if tap/click is on an interactive control (e.g. back button, links, inputs, action pills)
            try {
                const t = evt && evt.target;
                if (
                    t &&
                    t.closest &&
                    (
                        t.closest('.back-cta') ||
                        t.closest('.poi-actions') ||
                        t.closest('.vs-button') ||
                        t.closest('button') ||
                        t.closest('a') ||
                        t.closest('input') ||
                        t.closest('select') ||
                        t.closest('textarea')
                    )
                ) {
                    return; // let the control handle its click/tap
                }
            } catch (e) { console.warn(e); }

            const y = this.getClientY(evt);
            if (y == null) return;
            const rect = this.innerEl.getBoundingClientRect();
            const offsetY = y - rect.top;
            const handleHeight = 36; // keep in sync with handle hit area
            if (offsetY <= handleHeight) {
                if (evt && typeof evt.preventDefault === 'function') {
                    try { evt.preventDefault(); } catch (_) {console.warn(_);}
                }
                this.onGrabStart(evt);
            }
        },

        async initGallery() {
            console.log('init gallery')
            let $lgSwiper = document.getElementById('lg-swipper');
            const swiper = new Swiper('.swiper', {
                

                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },

                slidesPerView: 1,
                slidesPerGroup: 1,
                centeredSlides: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                spaceBetween: 50,
                loop: false,

                lazy: true,

                // Init lightGallery ince swiper is initilized
                on: {
                    init: function () {
                        const lg = window.lightGallery($lgSwiper);

                        // Before closing lightGallery, make sure swiper slide
                        // is aligned with the lightGallery active slide
                        $lgSwiper.addEventListener('lgBeforeClose', () => {
                            swiper.slideTo(lg.index, 0)
                        });
                    },
                }
            });

            // add events to navigation buttons
            document.querySelector('.swiper-button-next').addEventListener('click', () => {
                // if it's the last slide, go to the first one
                if (swiper.isEnd) {
                    swiper.slideTo(0);
                    return;
                }
                swiper.slideNext();
            });

            document.querySelector('.swiper-button-prev').addEventListener('click', () => {
                // if it's the first slide, go to the last one
                if (swiper.isBeginning) {
                    swiper.slideTo(swiper.slides.length - 1);
                    return;
                }
                swiper.slidePrev();
            });
        },

        async togglePoiLike() {
            if (this.poi == null) {
                return;
            }
            this.poi.liked = !this.poi.liked;

            // call the api to toggle the like
            const response = await apiCall('PUT', '/pois/' + this.poi.id + '/like', {
                liked: this.poi.liked
            })
            if (response.status == 200) {
                // success
                this.$vs.notification({
                    title: this.$t('common.messages.success'),
                    text: this.$t('common.poi') + ' ' + (this.poi.liked ? this.$t('common.addedTo').toLowerCase() : this.$t('common.removedFrom').toLowerCase()) + ' ' + this.$t('common.favourites').toLowerCase(),
                    color: 'success',
                    position: 'top-right'
                })
            } else if (response.status != 0) {
                // show an error message
                this.$vs.notification({
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('poi.messages.cannotAddToFavourites'),
                    color: 'danger',
                    position: 'top-right'
                })
                this.poi.liked = !this.poi.liked;
            }
        },

        upgrade() {
            this.upgradeLoading = true;
            setTimeout(() => {
                this.upgradeLoading = false;
                this.upgradeTooltip = false;
                this.$router.push({
                    name: 'Sottoscrizione'
                })
            }, 1000);
        },

        async togglePoiMyPlaces() {
            if (this.poi == null) {
                return;
            }

            if (this.user.subscription == null && !this.user.is_partner && !this.user.is_admin) {
                this.upgradeTooltip = true;
                return;
            }

            this.poi.my_place = !this.poi.my_place;

            // call the api to toggle the like
            const response = await apiCall('PUT', '/pois/' + this.poi.id + '/myplaces', {
                added: this.poi.my_place
            })
            if (response.status == 200) {
                // success
                this.$vs.notification({
                    title: this.$t('common.messages.success'),
                    text: this.$t('common.poi') + ' ' + (this.poi.my_place ? this.$t('common.addedTo').toLowerCase() : this.$t('common.removedFrom').toLowerCase()) + ' ' + this.$t('explore.myPlaces').toLowerCase(),
                    color: 'success',
                    position: 'top-right'
                })
            } else if (response.status != 0) {
                // show an error message
                this.$vs.notification({
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('poi.messages.cannotAddToMyPlaces'),
                    color: 'danger',
                    position: 'top-right'
                })
                this.poi.my_place = !this.poi.my_place;
            }
        },

        async openWebsite() {
            if(this.$IS_APP){
                Browser.open({ url: this.poi.website, presentationStyle: 'popover' });
            } else {
                // open the url in new window
                window.open(this.poi.website, '_blank');
            }
            
        },

        getDirections() {
            window.open('https://www.google.com/maps/search/?api=1&query=' + this.poi.latitude + ',' + this.poi.longitude);
        },

        async getPoi(id) {
            const loading = this.$vs.loading();
            const response = await apiCall('GET', '/pois/' + id, {
                include_like_details: true,
                include_my_places_details: true
            });
            if (response.status == 200) {
                var poi = response.data;
                GlobalEventEmitter.$emit('setZoom', 15)
                GlobalEventEmitter.$emit('goToCoords', [poi.latitude, poi.longitude])

                if (poi.pictures && poi.pictures.length > 0) {
                    // load images from S3
                    let images = [];

                    for (let i = 0; i < poi.pictures.length; i++) {
                        const image = poi.pictures[i];
                        const s3Response = await s3Client.getSignedDownloadURL({
                            name: image.name,
                        })
                        if (s3Response && s3Response.url) {
                            images.push({
                                url: s3Response.url,
                                description: image.description,
                                transition: 'kenburn'
                            })
                        }
                    }

                    this.googleImages = images;
                }

                this.poi = poi;
            } else if (response.status != 0) {
                this.$vs.notification({
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('poi.messages.cannotLoadPoi'),
                    color: 'danger',
                    position: 'top-right'
                })
            }
            loading.close();
        },

        addToTrip() {
            GlobalEventEmitter.$emit('showDialog', AddToTripDialog, this.addToTripCallback)
        },

        async addToTripCallback(e) {
            if (e === null) {
                // creare nuovo trip
                GlobalEventEmitter.$emit('showDialog', NewTripDialog, this.newTripCallback) // chiedo il nome
            } else if (e !== false && e.id != null) {
                var tripDetails = await this.getTrip(e.id)
                if (tripDetails != null) {
                    this.selectedTrip = tripDetails;
                    GlobalEventEmitter.$emit('showDialog', TripDateDialog, this.addToTripDateChosenCallback, tripDetails) // chiedo la data in cui intende visitare il poi

                }
            }

        },

        async addToTripDateChosenCallback(e) {
            console.log(e)
            if (e != null && e.length > 0) { // ha scelto un nome per il viaggio e ha premuto "prosegui" (non annulla)
                // to do, at the moment doesn't do anything
                if (this.selectedTrip.pois == null) {
                    this.selectedTrip.pois = []
                }
                this.selectedTrip.pois.push({
                    id: this.poi.id,
                    is_custom_poi: false,
                    start_date: e + 'T00:00:00Z',
                    end_date: e + 'T00:00:00Z',
                    position: this.selectedTrip.pois.length // to be sure it's the last one

                })
                console.log(this.selectedTrip)
                const loading = this.$vs.loading();
                await this.saveTrip();
                
                loading.close();

            }
        },

        async newTripCallback(e) {

            if (e != null && e.length > 0) { // ha scelto un nome per il viaggio e ha premuto "prosegui" (non annulla)
                if (await this.newTrip(e)) {
                    GlobalEventEmitter.$emit('showDialog', TripDateDialog, this.addToTripDateChosenCallback) // chiedo la data in cui intende visitare il poi
                }

            }
        },

        async getTrip(id) {

            // use apiCall to make a request to /trips
            const response = await apiCall('GET', '/journey/' + id);
            // if status code is 200, show a success message 
            if (response.status == 200) {
                return response.data;
            } else if (response.status != 0) {
                this.$vs.notification({
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('trips.messages.unableToLoadTrip'),
                    color: 'danger',
                    position: 'top-right'
                });

            }
            return null;
        },

        async saveTrip() {

            const response = await apiCall('PUT', '/journeys/' + this.selectedTrip.id, this.selectedTrip);
            // if status code is 200, show a success message 
            if (response.status == 200) {
                // show sucecss message
                this.$vs.notification({
                    title: this.$t('common.messages.success'),
                    text: this.$t('trips.messages.tripUpdated'),
                    color: 'success',
                    position: 'top-right'
                });
                return true;
            } else if (response.status == 409) {
                // show sucecss message
                this.$vs.notification({
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('trips.messages.poiAlreadyInTrip'),
                    color: 'danger',
                    position: 'top-right'
                });
            } else if (response.status != 0) {
                this.$vs.notification({
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('poi.messages.cannotAddToTrip'),
                    color: 'danger',
                    position: 'top-right'
                });
            }
            return false;
        },

        async newTrip(name) {
            // use apiCall to make a request to /trips
            const response = await apiCall('POST', '/journeys', {
                name
            });
            // if status code is 200, show a success message 
            if (response.status == 200) {
                // show a success message
                this.$vs.notification({
                    title: this.$t('common.messages.success'),
                    text: this.$t('trips.messages.tripCreated'),
                    color: 'success',
                    position: 'top-right'
                });
                this.selectedTrip = {
                    id: response.data.id,
                    name
                }

                return true;

            } else if (response.status != 0) {
                this.$vs.notification({
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('trips.messages.cannotCreateTrip'),
                    color: 'danger',
                    position: 'top-right'
                });

            }
            return false;

        },

    }
}
</script>

<style scoped>
.poi-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding: 0;
    margin: 0;
    gap: 15px;
    width: 100%;
    padding-bottom: 25px;
    overflow-x: hidden;
}

.poi-container.mobile {
    padding-left: 0!important;
    padding-right: 0!important;
    padding-top: 0!important;
}

.map-gradient {
    height: 120px;
    width: 100%;
    min-height: 120px;
    position: relative;
}

.map-gradient div {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}

.map-gradient .gradient {

    z-index: 2000;
    background: linear-gradient(180deg, rgba(255, 255, 255, 1) 1%, rgba(255, 255, 255, 0.0001) 25%, rgba(255, 255, 255, 1) 100%);
}

p {
    margin: 0;
}

.poi-section {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
}

.vs-button {
    margin: 0 !important;
}

/* MOBILE */
@media (max-width: 600px) {
    .poi-container {
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
        padding-bottom: 32px !important;
        width: 100% !important;

    }

    /* Reserve space for global mobile navbar when POI is not in slideout */
    .poi-container.outside-slideout {
        padding-bottom: 125px !important;
    }

    .poi-section {
        padding-left: 22px;
        padding-right: 22px;
        box-sizing: border-box;
    }

    /* Make POI content scrollable, keep slideout grabber fixed */
    .poi-container.mobile {
        height: calc(var(--sheet-height));
        max-height: calc(var(--sheet-height));
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: none;
    }

}

.content-tooltip {
    padding: 10px;
    box-sizing: border-box;
}

.content-tooltip button {
    margin: 0;
    margin-bottom: 5px;
}
</style><style>
.swiper-lg-wrap {
    height: 0;
    position: relative;
    max-width: 100%;
}

.swiper {
    width: 100%;
    height: 200px;
    position: relative;
}

.swiper .swiper-slide {
    height: auto;
}

.swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.swiper-slide p {
    max-width: 90%;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    position: absolute;
    top: 0;
    right: 5px;
    border-radius: 8px;
    text-align: center;
    padding: 8px;
    box-sizing: border-box;
}

.swiper-pagination-bullet {
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  color: #000;
  opacity: 1;
  background: rgba(0, 0, 0, 0.2);
}
.swiper-pagination-bullet-active {
  color: #fff;
  background: #007aff;
}


.slider-two .swiper-pagination-bullet-active{
   background: red;
}

.swiper-button-next, .swiper-button-prev {
    top: 100px;
    color: white!important;
}

.swiper-button-next::after, .swiper-button-prev::after {
    font-size: 18px;
}

/* Top hero with gallery + overlay back button */
.poi-hero {
    position: relative;
    width: 100%;
    border-radius: 14px;
    margin-top: 0px;
    margin-bottom: 8px;
}
.poi-hero .back-cta.overlay {
    position: absolute;
    top: 0;
    left: 0;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    color: #fff !important;
    text-shadow: 0 1px 2px rgba(0,0,0,.45);
    height: auto !important;
    padding: 6px 4px !important;
    z-index: 4000; /* ensure it sits above grabber/overlays */
    pointer-events: auto;
}
.poi-hero .back-cta.overlay img {
    filter: brightness(0) invert(1);
    margin-right: 6px !important;
}
.poi-hero .ai-source-chip {
    position: absolute;
    bottom: 6px;
    right: 8px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.70)!important;
    -webkit-backdrop-filter: saturate(150%) blur(10px);
    backdrop-filter: saturate(150%) blur(10px);
    border: 1px solid rgba(39,48,63,0.12);
    color: #27303f;
    box-shadow: 0 6px 16px rgba(16,24,40,0.12);
    padding: 6px 10px;
    z-index: 4001;
}
.poi-hero .ai-source-chip img {
    width: 16px;
    height: 16px;
    filter: none;
    margin: 0;
}
.poi-hero .ai-source-chip span {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .2px;
    white-space: nowrap;
}

/* Sticky top navbar (mobile) */
.poi-navbar {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 4002;
    background: rgba(255, 255, 255, 0.92) !important;
    -webkit-backdrop-filter: saturate(150%) blur(10px);
    backdrop-filter: saturate(150%) blur(10px);
    border-bottom: 1px solid rgba(39, 48, 63, 0.08);
    box-sizing: border-box;
    padding: 8px 12px;
    display: flex;
    align-items: center;
}
.poi-navbar .back-cta.nav {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    color: #27303f !important;
    height: auto !important;
    padding: 0 !important;
    display: inline-flex !important;
    align-items: center;
    gap: 6px;
}
.poi-navbar .back-cta.nav img {
    width: 20px;
    height: 20px;
    margin: 0;
    filter: none;
}
.poi-navbar .back-cta.nav span {
    font-weight: 600;
}

/* Reviews embedded navbar in slideout: reuse poi-navbar chrome, center title */
.reviews-navbar {
    position: relative;
    padding-left: 0 !important;    /* hug left edge */
    padding-right: 8px !important; /* small right padding symmetry */
    margin-bottom: 8px;
}
.reviews-navbar .back-cta.nav {
    margin-left: -14px !important; /* align arrow+label closer to the rounded corner */
}
.reviews-navbar .back-cta.nav .vs-button__content {
    gap: 4px !important;           /* tighten space between arrow and "Indietro" */
}
.reviews-navbar .title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);   /* perfectly center regardless of left control width */
    font-weight: 800;
    letter-spacing: 0.2px;
    text-align: center;
    pointer-events: none;          /* avoid accidental clicks on centered title */
}

/* Visible grabber inside slideout navbars (reviews/editor) */
.reviews-navbar .grabber-handle {
    position: absolute;
    left: 50%;
    top: 8px;
    transform: translateX(-50%);
    width: 36px;
    height: 4px;
    border-radius: 999px;
    background: rgba(39,48,63,0.28);
    pointer-events: none; /* let the slideout's handle area capture the drag */
}

/* Apple Maps–like mobile pills (light theme, no extra data) */
@media (max-width: 600px) {
    .poi-actions {
        width: 100%;
        padding: 10px 22px;
        box-sizing: border-box;
        /* allow pills to render outside without clipping; scrolling handled by inner wrapper */
        overflow: visible;
    }
    .poi-actions-scroll {
        width: 100%;
        display: flex;
        gap: 10px;
        overflow-x: auto;
        overflow-y: hidden; /* keep iOS/Safari happy so horizontal scroll works */
        -webkit-overflow-scrolling: touch;
        white-space: nowrap;
        scrollbar-width: none;
    }
    .poi-actions-scroll::-webkit-scrollbar { display: none; }
    .poi-actions .action-pill {
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        border-radius: 16px !important;
        background: rgba(255, 255, 255, 0.65) !important;
        -webkit-backdrop-filter: saturate(150%) blur(10px);
        backdrop-filter: saturate(150%) blur(10px);
        border: 1px solid rgba(39, 48, 63, 0.1) !important;
        color: #27303f !important;
        box-shadow: 0 6px 18px rgba(16,24,40,0.10);
        padding: 10px 14px !important;
        min-height: 44px !important;
        height: auto !important;
        width: auto !important;
        min-width: max-content;
        flex: 0 0 auto; /* never shrink */
        white-space: nowrap;
        overflow: visible;
        font-size: 14px !important;
        transition: transform .15s ease, box-shadow .25s ease, background-color .2s ease, border-color .2s ease;
        will-change: transform;
    }
    .poi-actions .action-pill img {
        width: 18px;
        height: 18px;
        margin-right: 8px;
    }
    .poi-actions .action-pill.primary {
        background: var(--primary) !important;
        color: #fff !important;
        border-color: var(--primary) !important;
        box-shadow: 0 10px 22px rgba(239,126,24,0.28);
    }
    /* prevent inner content from clipping or shrinking */
    .poi-actions .action-pill .vs-button__content {
        display: inline-flex !important;
        align-items: center;
        gap: 8px;
        white-space: nowrap !important;
        overflow: visible !important;
        text-overflow: clip !important;
        padding: 0 !important;
        max-width: none !important;
    }
    .poi-actions .action-pill.primary img {
        filter: brightness(0) invert(1);
    }
    .poi-actions .action-pill:active {
        transform: scale(.97);
        box-shadow: 0 4px 14px rgba(16,24,40,0.12);
    }
    .poi-hero .back-cta.overlay {
        transition: transform .12s ease, opacity .2s ease;
    }
    .poi-hero .back-cta.overlay:active {
        transform: scale(.96);
        opacity: .9;
    }
    @keyframes poi-fadeUp {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
    }
    .poi-container.mobile .poi-top-row { animation: poi-fadeUp .32s ease both; }
    .poi-container.mobile .poi-actions { animation: poi-fadeUp .34s ease both; }
    .poi-container.mobile > .poi-section:nth-of-type(1) { animation: poi-fadeUp .36s ease both; }
    .poi-container.mobile > .poi-section:nth-of-type(2) { animation: poi-fadeUp .38s ease both; }
    .poi-container.mobile > .poi-section:nth-of-type(3) { animation: poi-fadeUp .40s ease both; }
    .poi-container.mobile > .poi-section:nth-of-type(4) { animation: poi-fadeUp .42s ease both; }
    /* Centered title layout like Apple card */
    .poi-top-row {
        position: relative;
        margin-top: 4px;
        margin-bottom: 6px;
        padding: 0 4px;
    }
    .poi-top-row h3 {
        text-align: center;
        font-weight: 800;
        letter-spacing: 0.2px;
        font-size: 20px;
        line-height: 24px;
    }
    .poi-top-row .subtitle {
        text-align: center;
        color: rgba(39,48,63,0.70);
        font-size: 13px;
        line-height: 16px;
        margin: 2px 0 0 0;
    }
    .poi-top-row .vs-tooltip {
        position: absolute;
        right: 0;
        top: 0;
    }
    .poi-top-row .vs-tooltip .vs-button {
        width: 44px !important;
        height: 44px !important;
        border-radius: 999px !important;
        background: rgba(255, 255, 255, 0.65) !important;
        -webkit-backdrop-filter: saturate(150%) blur(10px);
        backdrop-filter: saturate(150%) blur(10px);
        border: 1px solid rgba(39, 48, 63, 0.1) !important;
        box-shadow: 0 8px 20px rgba(16,24,40,0.12);
    }
    .poi-top-row .vs-tooltip .vs-button img {
        width: 20px !important;
        height: 20px !important;
        margin: 0 !important;
    }
    .poi-section .bold {
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: rgba(39,48,63,0.55);
        margin-bottom: 2px;
    }
    .poi-section p:not(.bold) {
        font-size: 15px;
        color: #27303f;
    }
}



/* Slideout closing animation when dismissing via back button */
.poi-mobile-panel.slideout.closing {
    transition: transform .32s cubic-bezier(.2,.8,.2,1) !important;
    transform: translateY(100vh);
}
.poi-container.closing {
    animation: poi-slide-down .32s cubic-bezier(.2,.8,.2,1) forwards;
}
@keyframes poi-slide-down {
    from { transform: translateY(0); }
    to   { transform: translateY(100vh); }
}
</style>
